import { pick } from 'dot-object'
import { useData } from './useData'

export function useValue<T>(path: string) {
  const { data } = useData()

  return { value: pick(path, data) as T }
}
